import sdHandChronoH from '@/components/parts/hands/HandChronoH';
import sdHandChronoM from '@/components/parts/hands/HandChronoM';
import sdHandHour from '@/components/parts/hands/HandHour';
import sdHandMinute from '@/components/parts/hands/HandMinute';
import sdHandSecond from '@/components/parts/hands/HandSecond';
import sdHandSmallSecond from '@/components/parts/hands/HandSmallSecond';

export default {
  R513: {
    timeHour: sdHandHour,
    timeMinute: sdHandMinute,
    timeSecond: sdHandSecond,
  },
  R515: {
    timeHour: sdHandHour,
    timeMinute: sdHandMinute,
    timeSecond: sdHandSecond,
  },
  R517: {
    timeHour: sdHandHour,
    timeMinute: sdHandMinute,
    timeSecond: sdHandSecond,
  },
  R3520: {
    timeHour: sdHandHour,
    timeMinute: sdHandMinute,
    timeSecond: sdHandSmallSecond,
    chronoHour: sdHandChronoH,
    chronoMinute: sdHandChronoM,
    chronoSecond: sdHandSecond,
  },
  R3540: {
    timeHour: sdHandHour,
    timeMinute: sdHandMinute,
    timeSecond: sdHandSmallSecond,
    chronoHour: sdHandChronoH,
    chronoMinute: sdHandChronoM,
    chronoSecond: sdHandSecond,
  },
};
